import { FullPageWrapper } from "@repo/ui/index.tsx";

function NewEndorsementIframe() {
  const iframeUrl =
    "https://preview-vercel-wireframe-design-kzmqdhaw8z400nfoh8b0.vusercontent.net/";
  return (
    <FullPageWrapper>
      <iframe
        className="w-full h-[calc(100vh-90px)] "
        src={iframeUrl}
        title="Broker Channel"
        allowFullScreen
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      />
    </FullPageWrapper>
  );
}

export default NewEndorsementIframe;
